import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcSwapHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 10.5,
			width: 16,
			height: 2,
			rx: 1,
			fill: "#091F24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 7.5L27 11.5L21 15.5V7.5Z",
			fill: "#091F24"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 19.5,
			width: 16,
			height: 2,
			rx: 1,
			fill: "#091F24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 16.5L5 20.5L11 24.5V16.5Z",
			fill: "#091F24"
		})
	]
});
export default SvgIcSwapHorizontal;
